<template>  

  <div class="main-body">
   <MainHeader/>

   <div id="main-content-list">

    <div v-if="contentList.length > 0" class="top-banner-container">
      <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
        <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
      </a>
      <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
        <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
      </a>
    </div>

    <div class="first-title-blck">
      <div v-if="firstReviewTitle.length>0" class="review-title">
        <span v-if="parseInt(commentPageNum(0)) > 0"><a class="title-link" :href="'../reviews/?p='+reviewId">re: {{firstReviewTitle}}</a></span>
        <span v-else>{{firstReviewTitle}}</span>
      </div>
    </div>


  <div v-for="(review,i) in contentList" :key="review">

      <div v-if="i>0" class="search-form-blck">
       <SearchBlock :post_id="review['main'][0].ID"/>
      </div>

     <div :id="'content-blck-'+review['main'][0].ID" :class="'content-blck'+firstContentBlck(i)+contentCornerStyle(i)" :style="'background-color:'+postBg[i]">

     <!-- Top banner ad container for reviews 2+ -->
     <div v-if="!review['main'][0].IDnum && review['main'][0].no_cost !=1 && i>0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner">
       <!-- Fallback banner - shown when Google ads fail -->
       <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
         <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
       </a>
       <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
         <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
       </a>
     </div>


        <div v-if="i<1" class="category-menu">
          <a href="https://www.reviewstream.com" title="ReviewStream.com - consumer reviews"><span class="category-menu-website">ReviewStream.com</span></a>
          <span class="category-menu-raquo">&raquo;</span>
          <a :href="'../reviews/?cat='+review['main'][0].post_category" :title="'Reviews on '+review['category_description']"><span class="category-menu-category">{{review['category_description']}}</span></a>
        </div>        
      
        <div :id="'content-title-'+review['main'][0].ID">

            <div v-if="i>0" class="review-title" :id="'title-'+review['main'][0].ID">
                {{review['main'][0].post_title}}
            </div>

            <div v-if="review['main'][0].location" class="location-address">
                {{review['main'][0].location}}
            </div>
        </div>

        <div v-html="review['main'][0].videoCode" v-if="review['main'][0].videoCode" class="video-trailer"></div>   
  

        <div v-if="(i==0 && parseInt(commentPageNum(i)) == 0) || i>0">
      
          <div class="summary-blck" :id="'summary-blck-'+review['main'][0].ID">
              <div v-if="review['main'][0].summary1" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-1'">
              <div id="summary-1-txt">{{review['main'][0].summary1}}</div>
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 1, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 1, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  

                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 1, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="1"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',1,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
    
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-1')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-1',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

              </div>

              <div v-if="review['main'][0].summary2" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-2'">
              <div id="summary-2-txt">{{review['main'][0].summary2}}</div>
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 2, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 2, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div> 
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 2, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="2"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',2,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-2')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-2',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

              </div>

              <!-- Mobile top banner for first review -->
              <div v-if="isMobile() && !review['main'][0].IDnum && review['main'][0].no_cost !=1 && i==0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner top-banner-mobile">
                <!-- Fallback banner - shown when Google ads fail -->
                <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
                  <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                </a>
              </div>

              <div v-if="review['main'][0].summary3" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-3'">
              <div id="summary-3-txt">{{review['main'][0].summary3}}</div> 
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 3, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 3, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 3, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="3"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',3,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-3')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-3',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

              </div>
              <div v-if="review['main'][0].summary4" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-4'">
              <div id="summary-4-txt">{{review['main'][0].summary4}}</div> 
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 4, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 4, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 4, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="4"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',4,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-4')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-4',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>
          
              </div>
              <div v-if="review['main'][0].summary5" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-5'">
              <div id="summary-5-txt">{{review['main'][0].summary5}}</div> 
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 5, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 5, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 5, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="5"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',5,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-5')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-5',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

              </div>
          </div>

          <!-- Desktop top banner for first review -->
          <div v-if="!isMobile() && !review['main'][0].IDnum && review['main'][0].no_cost !=1 && i==0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner">
            <!-- Fallback banner - shown when Google ads fail -->
            <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
              <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
            </a>
          </div>

          <div :id="'content-txt-'+review['main'][0].ID" class="content-txt">

              <div v-if="review['main'][0].main_pic && review['main'][0].submType == 0" class="blck-main-pic">
                <picture>
                  <source :srcset="'../images_items_webp/'+imageWebpFileName(review['main'][0].main_pic)" type="image/webp">
                  <source :srcset="'../images_items/'+review['main'][0].main_pic" type="image/jpeg"> 
                  <img :width="review['main'][0].picwidth" :height="review['main'][0].picheight" :src="'../images_items/'+review['main'][0].main_pic" :alt="'Personal review of '+review['main'][0].post_title" :title="'Personal review of '+review['main'][0].post_title" loading="lazy"/>
                </picture>
              </div>

              <div v-html="review['main'][0].post_content" class="review-content" :id="'review-'+review['main'][0].ID"></div>
          </div>        
          <div class="review-credentials">
                  <div class="author-name" v-if="review['main'][0].nick">by @{{review['main'][0].nick}}</div>
                  <div class="author-name" v-else>by @anonymous</div>
            <div class="author-blck">
              <div class="byauthor">
                  <div v-if="review['main'][0].photo_url" class="author-pic">
                    <img :src="'../authors/images/'+review['main'][0].photo_url" :title="'Review author: '+review['main'][0].nick" :alt="'Review author: '+review['main'][0].nick" loading="lazy"/>
                  </div>
                  <div v-else class="opacity-01">
                          <picture>
                              <source srcset="./assets/icons/ghost.webp" type="image/webp">
                              <source srcset="./assets/icons/ghost.jpg" type="image/jpeg"> 
                              <img width="200" height="120" src="./assets/icons/ghost.jpg" alt="anonymous author" title="anonymous author" loading="lazy"/>
                          </picture>
                  </div>  
                  <div class="trust-block">
                      <TrustChart :trust_data="Math.round(review['main'][0].TR)" />
                  </div>
              </div> 
            </div>

              <div class="voting-blck">
                  <div class="like-blck" :id="'like-review-'+review['main'][0].ID" @click="likeSubmit('1',review['main'][0].ID,review['review_voting_url'][0])">
                    <img class="like-img" alt="LIKE" title="LIKE review" src="./assets/icons/likes/like-review.png" loading="lazy"/>
                    <div class="like-thanks" :id="'like-thanks-'+review['main'][0].ID">Thank you :)</div>
                  </div>
                  <div class="dislike-blck" :id="'dislike-review-'+review['main'][0].ID" @click="likeSubmit('2',review['main'][0].ID,review['review_voting_url'][1])">
                    <img class="dislike-img" alt="DISLIKE" title="DISLIKE review" src="./assets/icons/likes/dislike-review.png" loading="lazy"/>
                    <div class="dislike-thanks" :id="'dislike-thanks-'+review['main'][0].ID">Thank you :)</div>
                  </div>
              </div>  
            </div>
        </div>


        <!---QUESTIONS AND ANSWERES-->
        <div class="comments-blck-title" :id="'comments-blck-'+review['main'][0].ID"><img class="chat-icon" src="./assets/icons/chat-icon.png?v=1" alt="Questions, Answers, Comments"/>Questions, Answers, Comments</div>
   
     <div v-for="(commentsCluster,clusterKey) in review['comments']" :key="clusterKey" class="cluster-wrapper">
        <div class="cluster-vote-wrapper">
           <div v-for="(comment,ii) in commentsCluster" :key="ii" class="commentsBlck" :id="'commentBlck-'+comment.relations">

            <a class="aname" :name="comment.relations"></a>
            <div v-if="comment.relations" :class="isClusterStart(comment.relations)" :id="'commentsClusterBlck-'+comment.relations">

                <div v-html="commentBy(comment.comment_by, comment.comment_author)" class="comment-author-blck"></div>  
                <div v-html="postComment(comment.comment_content)"></div>

             <!-- Comment banner ad container -->
             <!-- FIX: removed duplicate closing quote from :id attribute -->
             <div v-if="i<2" class="inner-banner comment-banner" :id="'comment-banner-'+comment.relations">
               <!-- Fallback banner - shown when Google ads fail -->
               <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                 <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
               </a>
               <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
                 <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
               </a>
             </div>

               <div class="comment-btns">
                  <div class="comments-btns-reply">
                    <button class="comment-reply-btn" @click="addReplyCommentForm(comment.relations,replyCommentFormShown)" :id="'reply-btn-'+comment.relations" :data-realtions="comment.relations">Reply</button>
                  </div>
                  <div class="comment-btns-social">
                    <div class="comment-btns-social-twitter">
                     <a target="_blank" :href="'https://twitter.com/intent/tweet?url=https%3A%2F%2Freviewstream.com%2Freviews%2F%3Fp%3D'+review['main'][0].ID+'%23'+comment.relations">
                       <picture>
                          <source srcset="./assets/icons/twitter_icon.webp" type="image/webp">
                          <source srcset="./assets/icons/twitter_icon.png" type="image/jpeg"> 
                          <img width="40" height="40" src="./assets/icons/twitter_icon.png" alt="Twitter share" title="Twitter share" loading="lazy"/>
                       </picture>
                     </a>
                   </div>
                   <div class="comment-btns-social-facebook">
                     <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Freviewstream.com%2Freviews%2F%3Fp%3D'+review['main'][0].ID+'%23'+comment.relations">
                      <picture>
                          <source srcset="./assets/icons/facebook_icon.webp" type="image/webp">
                          <source srcset="./assets/icons/facebook_icon.png" type="image/jpeg"> 
                          <img width="40" height="40" src="./assets/icons/facebook_icon.png" alt="Facebook share" title="Facebook share" loading="lazy"/>
                       </picture>
                     </a>
                   </div>
                </div>

             </div> 

             <!--- show newly added replies to other comments --->
              <div v-for="(newcomment,iii) in addedComments" :key="iii" class="commentsBlck">
               <div v-if="review['main'][0].ID == addedComments[iii].post_id && comment.relations == addedComments[iii].relation_id" class="commentsClusterBlck">
                 <div v-html="commentBy('', addedComments[iii].author)" class="comment-author-blck"></div>
                 <div v-html="addedComments[iii].newcomment"></div>
                 <div class="greeting-message" v-html="addedComments[iii].greetingMsg"></div>
               </div>   
              </div>

               <!---- dynamically add comment form on Reply button click --->
               <div v-if="replyCommentFormShown.indexOf(comment.relations)>-1" :id="'addReplyCommentBlck-'+comment.relations" class="relative">
                  <ReplyCommentForm :relation="comment.relations" :post_id="review['main'][0].ID" :addedComments="addedComments" :submitCommentParent="submitComment" :count="i"/>
               </div>

            </div>   

             <div v-if="ii == commentsCluster.length - 1" class="cluster-vote-blck">
                <div class="cluster-vote-title">helpful ?</div>
                <div class="cluster-vote-arrow" v-on:click="clusterHelpfulVote(comment.relations, '2')">NO</div>
                <div class="cluster-vote-arrow" v-on:click="clusterHelpfulVote(comment.relations, '1')">YES</div>
                <div class="cluster-vote-result" :id="'cluster-vote-'+comment.relations">{{comment.claster_score}}</div>
             </div>

         </div>

        </div>

      </div>

          <!--- show newly added comments to the whole review --->
           <div v-for="(newcomment,c) in addedComments" :key="c" class="commentsBlck">
            <div v-if="review['main'][0].ID == addedComments[c].post_id && addedComments[c].relation_id == ''" class="commentsClusterBlck">
              <div v-html="commentBy('', addedComments[c].author)" class="comment-author-blck"></div>
              <div v-html="addedComments[c].newcomment"></div>
         
         <!-- Fallback banner immediately below submit button -->
         <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
             <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
           </a>
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
             <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
           </a>
         </div>
              <div class="greeting-message" v-html="addedComments[c].greetingMsg"></div>  
            </div> 
           </div>


        <div v-if="review['main'][0].total_clusters > commentClusterPerPage" class="more-comments-blck">
             <MoreCommentsButtons 
                   :post_id="review['main'][0].ID" 
                   :total_comments="review['main'][0].total_comments" 
                   :total_clusters="review['main'][0].total_clusters" 
                   :cluster_perpage="commentClusterPerPage" 
                   :pageNum="commentPageNum(i)"/> 
        </div>


        <div>
         <input name="comment-author-input" class="comment-details-input comment-blck-top" :id="'comment-author-input-'+review['main'][0].ID" placeholder="Your name (required)" />
         <input name="comment-author-email-input" class="comment-details-input" :id="'comment-author-email-input-'+review['main'][0].ID" placeholder="Your email (required for the review author)"/>
         <textarea name="comment-input" class="comment-input" :id="'comment-input-'+review['main'][0].ID" placeholder="Share your thoughts. Ask. Your opinion is valuable."></textarea>  
         <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'')">submit comment</button>

         <div v-if="i===0" class="comment-banner-container">
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
             <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
           </a>
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
             <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
           </a>
         </div>

         <!-- Fallback banner immediately below submit button -->
         <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
             <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
           </a>
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
             <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
           </a>
         </div>
        </div>

      </div>
      <div v-if="relatedContentRightColumn && relatedContentRightColumn.length > 0">
        <div class="related-blck-title" :id="'related-blck-'+review['main'][0].ID"><img class="related-icon" src="./assets/icons/related.png?v=1" alt="related reviews icon" title="related reviews icon" loading="lazy"/>Related reviews</div>
        <div class="bottom-related-blck">
          <div v-for="related in relatedContentRightColumn.slice(0, 5)" v-bind:key="related">
            <a :href="related.related_link" :title="related.related_title" :alt="related.related_title" class="bottom-related-link">
            <div class="bottom-rel-title">
              {{ related.related_title }}
            </div>
            </a> 
          </div> 
        </div>
      </div>

      </div>

   </div>

  </div>

</template>

<script>
  import MainHeader from './components/MainHeader.vue'
  import SearchBlock from './components/SearchBlock.vue'
  import TrustChart from './components/TrustChart.vue'
  import ReplyCommentForm from './components/ReplyCommentForm.vue'
  import SummaryCommentForm from './components/SummaryCommentForm.vue'
  import MoreCommentsButtons from './components/MoreCommentsButtons.vue'
  import {fade} from '@/assets/js/global.js'
  import {defineAsyncComponent, inject, defineComponent} from 'vue'
  import { ref, onBeforeMount, onUnmounted, onMounted } from 'vue'
  import {unescape} from 'html-escaper'
  import { gsap } from "gsap"
  import { ScrollTrigger } from "gsap/ScrollTrigger"
  gsap.registerPlugin(ScrollTrigger)

  const VueFeather = defineAsyncComponent(() =>
     import('vue-feather')
  )

  export default defineComponent({
    components: {
      VueFeather,
      SummaryCommentForm,
      ReplyCommentForm,
      MainHeader,
      SearchBlock,
      TrustChart,
      MoreCommentsButtons,
    },
    data: function() {
      return {
        replyCommentFormShown: [],
        addedComments: [],
        summaryCommentFormShown: [],
        summaryCommentGreetingAll: [
          'Great input.',
          'Helpful as usual.',
          'You are the best.',
          'You will be rewarded.',
          'Pleasure to assist you.'
        ],
        summaryCommentGreetingToShow: []
      }
    },
    setup() {

      const gtag = inject('gtag')
      const okBannerClicked = () => {}

      let urlObject = new URL(document.location.href)
      let params = urlObject.searchParams
      let reviewId = params.get("p")
      let commentPageNum = (i) => {
        if (!params.get("n") || i > 0) {
          return "0"
        } else {
          return params.get("n")
        }
      }

      let commentClusterPerPage = 100

      let firstReviewTitle = ref([])
      let content = ref([])
      let content_shown = ref([])
      let contentList = ref([])

      let relatedContent = ref([])
      let relatedContentRightColumn = ref([])
      let relatedShown = 0
      let mainCategory = 0
      let categoryShown = 0
      let isCategory = false
      let totalShown = 1
      let doFetch = true
      let summaryCommentGreetingShown = ref([])

      let postBg = ref([])

      let isMobile = () => {
        return window.innerWidth <= 420
      }

      let handleScroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 1000) {
          if (!content_shown.value.includes(reviewId) && totalShown > 1 && doFetch) {
            fetchContent(reviewId, mainCategory, commentClusterPerPage)
            doFetch = false
          }
        }
      }

      const fetchFirstTitle = async (r) => {
        try {
          if (r > 0) {
            let firstTitleResponse = await fetch('../reviews/api/first-review-title.php?do=' + r)
            const parsedFirstTitleResponse = await firstTitleResponse.json()
            firstReviewTitle.value = parsedFirstTitleResponse
          }
        } catch (err) {
          // handle error silently
        }
      }

      const fetchContent = async (r, c, commentClusterPerPage, commentsPageNum) => {
        try {
          let mainResponse
          if (r != null && r > 0) {
            mainResponse = await fetch('../reviews/api/review.php?do=' + r + '&total=' + totalShown + '&comments=' + commentClusterPerPage + '&n=' + commentsPageNum)
          } else {
            mainResponse = await fetch('../reviews/api/review.php?cat=' + c + '&show=' + categoryShown + '&total=' + totalShown + '&comments=' + commentClusterPerPage + '&n=' + commentsPageNum)
            isCategory = true
          }
          const parsedResponse = await mainResponse.json()

          if (JSON.stringify(parsedResponse) != 1) {
            content.value = parsedResponse

            if (mainCategory == 0) {
              mainCategory = content.value.main[0].post_category
            }

            if (content.value.main[0].ID > 0 && !content_shown.value.includes(content.value.main[0].ID)) {
              contentList.value = [...contentList.value, content.value]
              content_shown.value.push(content.value.main[0].ID)
              doFetch = true
              totalShown++
            }

            if (isCategory) { categoryShown++ }

            if (relatedContent.value.length == 0 || relatedContent.value.length == relatedShown) {
              relatedContent.value = Object.values(content.value.related_reviews).filter(function (objFromA) {
                return !content_shown.value.find(function (objFromB) {
                  return objFromA.related_id === objFromB
                })
              })

              relatedContentRightColumn.value = [...relatedContentRightColumn.value, ...relatedContent.value]

              if (relatedContent.value.length == 0 && mainCategory > 0) {
                reviewId = 0
                fetchContent(reviewId, mainCategory, commentClusterPerPage)
              } else {
                relatedShown = 0
                reviewId = relatedContent.value[0].related_id
              }
            } else {
              reviewId = relatedContent.value[relatedShown].related_id
            }

            relatedShown++
          }
        } catch (err) {
          console.log("Error message:", err.message)
          console.log("Stack trace:", err.stack)
        }
      }

      // FIX: onBeforeMount should call fetchContent directly, not wrap in unresolved Promise
      onBeforeMount(() => {
        fetchFirstTitle(reviewId)
        fetchContent(reviewId, mainCategory, commentClusterPerPage, params.get("n"))
      })

      onMounted(() => {
        window.addEventListener('scroll', handleScroll)
        ScrollTrigger.refresh()

        const topMenuScrollLessenStart = 'top 0'
        const topMenuScrollLessenEnd = 999999

        ScrollTrigger.create({
          start: topMenuScrollLessenStart,
          end: topMenuScrollLessenEnd,
          toggleClass: { className: 'top-menu-icon-container-scrolled', targets: '.top-menu-icon-container' },
        })
        ScrollTrigger.create({
          start: topMenuScrollLessenStart,
          end: topMenuScrollLessenEnd,
          toggleClass: { className: 'top-menu-scrolled', targets: '.top-menu' },
        })
        ScrollTrigger.create({
          start: topMenuScrollLessenStart,
          end: topMenuScrollLessenEnd,
          toggleClass: { className: 'header-logo-scrolled', targets: '.header-logo' },
        })
        ScrollTrigger.create({
          start: topMenuScrollLessenStart,
          end: topMenuScrollLessenEnd,
          toggleClass: { className: 'header-moto-scrolled', targets: '.header-moto' },
        })
        ScrollTrigger.create({
          start: topMenuScrollLessenStart,
          end: topMenuScrollLessenEnd,
          toggleClass: { className: 'header-left-menu-scrolled', targets: '.header-left-menu' },
        })

        let OnEvent = (doc) => {
          return {
            on: async (type, selector, callback) => {
              doc.addEventListener(type, (event) => {
                if (!event.target.matches(selector)) return
                callback.call(event.target, event)
              }, false)
            }
          }
        }

        OnEvent(document).on('click', '.comment-outgoing-link', async function (e) {
          try {
            let commentId = e.target.id.split(':::')[0]
            let linknum = e.target.id.split(':::')[1]

            const getOutgoingLinkUrl = "../reviews/outgoing_link_vue.php"
            const outLinkOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ details: commentId, linknum: linknum })
            }

            let outLinkResponse = await fetch(getOutgoingLinkUrl, outLinkOptions)
            let outLinkResponseData = await outLinkResponse.json()
            let outLinkReply = JSON.stringify(outLinkResponseData)

            if (outLinkReply == 1) {
              console.log('out link error')
            } else {
              if (JSON.stringify(outLinkResponseData) != 1) {
                let outgoingLinkDisclaimer = '<div class="outgoing-link-disclaimer">Disclaimer: ReviewStream.com is not responsible for the contents of any web page referenced from this server.</div>'
                let showCommentLinkBlck = document.getElementById('commentsClusterBlck-' + commentId)
                let showCommentLinkTxt = '<div class="outgoing-link"><a href="' + outLinkResponseData.link + '" target="_blank">' + outLinkResponseData.title + '</a>' + outgoingLinkDisclaimer + '</div>'
                showCommentLinkBlck.innerHTML += (showCommentLinkTxt)
              }
            }
          } catch (err) {
            console.log(err)
          }
        })
      })

      onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll)
      })

      // FIX: return block is now properly closed before methods
      return {
        relatedContent,
        relatedContentRightColumn,
        contentList,
        postBg,
        okBannerClicked,
        isMobile,
        summaryCommentGreetingShown,
        firstReviewTitle,
        commentClusterPerPage,
        commentPageNum,
        reviewId,
      }
    },
    // FIX: methods is now a top-level component option, not inside setup()'s return
    methods: {
      imageWebpFileName: (filename) => {
        let imageNameBase = filename.split('.')[0]
        return imageNameBase + '.webp'
      },
      commentsCountText: (total) => {
        if (total > 1) {
          return "comments"
        } else {
          return "comment"
        }
      },
      isClusterStart: (relations) => {
        if (relations.match(/:/)) {
          return "commentsClusterBlck related-comment"
        }
        return "commentsClusterBlck"
      },
      postComment: (txt) => {
        return unescape(txt.replace(/\r?\n|\r/g, '<br>'))
      },
      commentBy: (c, a) => {
        let by
        if (!c) { by = a + ' says' }
        else if (!a) { by = 'quick note by anonymous' }
        else if (c == 'Q') { by = a }
        else if (c == 'AA') { by = '<span class="author-comment-sign">author</span> ' + a + ' adds' }
        else { by = '<span class="author-comment-sign">author</span> ' + a + ' replies' }
        return by
      },
      addReplyCommentForm(r, replyCommentFormShown) {
        replyCommentFormShown.push(r)
      },
      addSummaryCommentForm(review_id, summary_num, btn_clicked, summaryCommentFormShown) {
        let newSummaryComment = { 'review_id': review_id, 'summary_num': summary_num, 'btn_clicked': btn_clicked }
        summaryCommentFormShown.push(newSummaryComment)
      },
      showSummaryCommentsForm(review_id, summary_num, summaryCommentFormShown) {
        let x = false
        for (let i = 0; i < summaryCommentFormShown.length; i++) {
          if (summaryCommentFormShown[i].review_id === review_id && summaryCommentFormShown[i].summary_num === summary_num) {
            x = true
          }
        }
        return x
      },
      showSummaryCommentGreeting(summaryCommentGreetingAll) {
        if (this.summaryCommentGreetingToShow.length === 0) {
          this.summaryCommentGreetingToShow = Array.from(summaryCommentGreetingAll)
        }
        for (let i = this.summaryCommentGreetingToShow.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [this.summaryCommentGreetingToShow[i], this.summaryCommentGreetingToShow[j]] = [this.summaryCommentGreetingToShow[j], this.summaryCommentGreetingToShow[i]]
        }
        let greetingToShow = this.summaryCommentGreetingToShow[0]
        this.summaryCommentGreetingToShow.shift()
        return '<div class="summary-greeting"><div class="summary-greeting-publish">Published.</div><div class="summary-greeting-text">' + greetingToShow + '</div><div class="summary-greeting-thanks">Thank you :)</div></div>'
      },
      fetchSummaryCommentGreeting(summary_id, summaryCommentGreetingShown) {
        return summaryCommentGreetingShown.find(x => x.summary === summary_id).greeting
      },
      ReadMoreClicked: async (event) => {
        let clickedDivPosition = event.target.getBoundingClientRect()
        let clickedDivFromTop = {
          top: clickedDivPosition.top + window.pageYOffset
        }
        await fetch('../reviews_vue/statistics/read-more-clicked-vue.php?top=' + clickedDivFromTop.top)
      },
      likeSubmit: async (like, review_id, voting_url) => {
        if (like == 1) {
          let el = document.getElementById('dislike-review-' + review_id)
          el.classList.add('collapse-dislike-blck')
        }
        if (like == 2) {
          let el = document.getElementById('like-review-' + review_id)
          el.classList.add('collapse-like-blck')
        }

        const reviewVoteUrl = "../reviews/votes_process_vue.php"

        try {
          const reviewVotingOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ vurl: voting_url })
          }

          let reviewVotePostResponse = await fetch(reviewVoteUrl, reviewVotingOptions)
          let reviewVotePostResponseData = await reviewVotePostResponse.json()
          let reviewVoteReply = JSON.stringify(reviewVotePostResponseData)

          if (reviewVoteReply == 1) {
            if (like == 1) {
              let likeThanksSign = document.getElementById('like-thanks-' + review_id)
              likeThanksSign.style.visibility = 'visible'
            }
            if (like == 2) {
              let dislikeThanksSign = document.getElementById('dislike-thanks-' + review_id)
              dislikeThanksSign.style.visibility = 'visible'
            }
          } else {
            window.location.href = "/"
          }
        } catch (err) {
          // handle error silently
        }
      },
      firstContentBlck(i) {
        if (i == 0) {
          return " content-blck-first"
        } else {
          return ""
        }
      },
      contentCornerStyle(i) {
        if (i < 2) {
          return " content-blck-corner-right"
        } else {
          return " content-blck-corner-left"
        }
      },
      searchBlockStyle(i, postBg) {
        if (i < 3) {
          return 'border-right:3px solid ' + postBg[i - 1]
        } else {
          return 'border-left:2px solid #E66D29'
        }
      },
      clusterHelpfulVote: async (cluster, vote) => {
        const clusterVoteUrl = "../reviews/cluster_votes_vue.php"

        try {
          const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ cluster: cluster, vote: vote })
          }

          let clusterVotePostResponse = await fetch(clusterVoteUrl, requestOptions)
          let clusterVotePostResponseData = await clusterVotePostResponse.json()
          let clusterVoteReply = JSON.stringify(clusterVotePostResponseData)

          if (clusterVoteReply == 1) {
            let clusterUpdateVote = document.getElementById('cluster-vote-' + cluster)
            let currentClusterVoteNum = parseInt(clusterUpdateVote.innerHTML)
            if (vote == "1") {
              clusterUpdateVote.innerHTML = (currentClusterVoteNum + 1)
            }
            if (vote == "2") {
              clusterUpdateVote.innerHTML = (currentClusterVoteNum - 1)
            }
          }
        } catch (err) {
          // handle error silently
        }
      },
      submitComment: async (id, addedComments, relationId, summary_num, summaryCommentFormShown, summaryCommentGreetingShown, summaryCommentGreetingCurrent) => {
        const commentUrl = "../reviews/questions_answers_vue.php"

        let commentTxt, commentAuthor, commentAuthorEmail
        let commentTxtInput, commentAuthorInput

        if (relationId) {
          commentTxtInput = document.getElementById('comment-input-' + relationId)
          commentAuthorInput = document.getElementById('comment-author-input-' + relationId)
          commentTxt = document.getElementById('comment-input-' + relationId).value.trim()
          commentAuthor = document.getElementById('comment-author-input-' + relationId).value.trim()
          commentAuthorEmail = document.getElementById('comment-author-email-input-' + relationId).value.trim()
        } else if (summary_num > 0) {
          commentTxtInput = document.getElementById('comment-input-' + id + '-sum-' + summary_num)
          commentAuthorInput = document.getElementById('comment-author-input-' + id + '-sum-' + summary_num)
          commentTxt = document.getElementById('comment-input-' + id + '-sum-' + summary_num).value.trim()
          commentAuthor = document.getElementById('comment-author-input-' + id + '-sum-' + summary_num).value.trim()
          commentAuthorEmail = document.getElementById('comment-author-email-input-' + id + '-sum-' + summary_num).value.trim()
        } else {
          commentTxtInput = document.getElementById('comment-input-' + id)
          commentAuthorInput = document.getElementById('comment-author-input-' + id)
          commentTxt = document.getElementById('comment-input-' + id).value.trim()
          commentAuthor = document.getElementById('comment-author-input-' + id).value.trim()
          commentAuthorEmail = document.getElementById('comment-author-email-input-' + id).value.trim()
        }

        if (!commentTxt || !commentAuthor) {
          if (!commentTxt) {
            commentTxtInput.style.background = '#ffff66'
            setTimeout(function () { commentTxtInput.style.background = '#ffffff' }, 1000)
          }
          if (!commentAuthor) {
            commentAuthorInput.style.background = '#ffff66'
            setTimeout(function () { commentAuthorInput.style.background = '#ffffff' }, 1000)
          }
          return
        } else {
          try {
            const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ review_id: id, txt: commentTxt, name: commentAuthor, email: commentAuthorEmail, relation: relationId, sumquote: summary_num })
            }

            let commentPostResponse = await fetch(commentUrl, requestOptions)
            let commentPostResponseData = await commentPostResponse.json()
            let commentReply = JSON.stringify(commentPostResponseData)

            let commentResponseText = ''

            if (commentReply == 1) {
              commentResponseText = 'Oops, something went wrong. Sorry for the inconvenience.'
            }
            if (commentReply == 5) {
              commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>Every comment increases your Trust Score.'
            }
            if (commentReply == 55) {
              commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>We appreciate your effort to make an Internet more informative. The review&#39;s author was notified about your message. We suggest you to bookmark this page to follow conversation.'
            }
            if (commentReply == 555) {
              commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>We appreciate your effort to make an Internet more informative. The review&#39;s and comment&#39;s authors were notified about your message. We suggest you to bookmark this page to follow conversation.'
            }

            if (summary_num > 0) {
              let summaryTxt = '<span id="comment_quote">re : ' + document.getElementById('summary-' + summary_num + '-txt').textContent + '</span><br>'
              commentTxt = summaryTxt + commentTxt
            }

            let newCommentDetails = {}
            newCommentDetails.author = commentAuthor
            newCommentDetails.newcomment = commentTxt
            newCommentDetails.post_id = id
            newCommentDetails.relation_id = relationId
            newCommentDetails.greetingMsg = commentResponseText

            addedComments.push(newCommentDetails)

            if (relationId != '') {
              let newReplyBlck = document.getElementById('addReplyCommentBlck-' + relationId)
              fade(newReplyBlck)

              let repliedBtn = document.getElementById('reply-btn-' + relationId)
              repliedBtn.innerText = 'Replied'
              repliedBtn.style.background = '#ffffff'
              repliedBtn.style.color = '#192f97'
            }

            document.getElementById("comment-input-" + id).value = ''
            commentResponseText = ''

          } catch (err) {
            console.log(err)
          }
        }

        if (summary_num > 0) {
          for (let i = 0; i < summaryCommentFormShown.length; i++) {
            if (summaryCommentFormShown[i].review_id === id && summaryCommentFormShown[i].summary_num === summary_num) {
              summaryCommentFormShown.splice(i, 1)
            }
          }
          summaryCommentGreetingShown.push({ 'summary': id + '-' + summary_num, 'greeting': summaryCommentGreetingCurrent })
        }
      }
    }
  })
</script>

<style>
.top-banner-container,
.comment-banner-container {
  width: 100%;
  overflow: hidden;
  text-align: center;
  margin: 20px 0;
}

.fallback-banner-link {
  display: block;
}

.fallback-banner {
  width: 100%;
  height: auto;
}

@media (min-width: 769px) {
  .fallback-mobile {
    display: none;
  }
  .fallback-desktop {
    display: block;
  }
  .fallback-banner.fallback-desktop {
    max-width: 970px;
  }
}

@media (max-width: 768px) {
  .fallback-desktop {
    display: none;
  }
  .fallback-mobile {
    display: block;
  }
  .fallback-banner.fallback-mobile {
    max-width: 360px;
    margin: 0 auto;
  }
}
</style>